import { createRoutine } from 'redux-saga-routines'

export const SET = 'EL_COLE/SET'
export const CONTENT = createRoutine('EL_COLE/CONTENT')
export const HOME_CONTENT = createRoutine('EL_COLE/HOME_CONTENT')
